import { useProjectDocumentsQuery } from "@src/__generated__/graphql";
import { NavigationProject } from "@src/components/widgets/AppSubNav/NavigationProject";
import { onError } from "@src/utils/apollo";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import {
  DocumentsCtx,
  StoreDocuments,
} from "../../documents/listing/StoreDocuments";
import { TableModuleDocuments } from "../../documents/listing/TableModuleDocuments";
import { MixedFilters } from "./MixedFilters";

interface DocumentsProps {
  id: string;
}

const Documents = ({ id }: DocumentsProps) => {
  const { data } = useProjectDocumentsQuery({
    variables: { id },
    ...onError(),
  });
  const [documentsStore] = useState(() => {
    const store = new StoreDocuments(new MixedFilters(id), true);
    return store;
  });
  const { query } = useRouter();

  documentsStore.setQuickFilterFromURL(query);

  useEffect(() => {
    documentsStore.setPrefillFormFields({
      projectId: id,
      brandId: data?.project?.brand.id,
    });
  }, [data]);

  return (
    <DocumentsCtx.Provider value={documentsStore}>
      <TableModuleDocuments navigation={<NavigationProject id={id} />} />
    </DocumentsCtx.Provider>
  );
};

export default observer(Documents);
